module.exports = __webpack_public_path__ + "363d318a1c7f96d7e6eb274c1c246941.svg";